/**
 * Centralized user navigation utilities
 * Handles user-specific routing and home directory determination
 */

export interface UserNavigationConfig {
  user: any;
  isAuthenticated: boolean;
}

/**
 * Determines the home directory based on user properties and authentication status
 */
export const getUserHomeDirectory = (user: any): string => {
  // If user is not available, return login page
  if (!user) {
    console.log('getUserHomeDirectory: No user provided, redirecting to login');
    return '/';
  }

  console.log('getUserHomeDirectory: User data:', user);

  // Check if user has restricted access (only assignments)
  if (user.onlyAssigned === true) {
    console.log('getUserHomeDirectory: User has onlyAssigned=true, redirecting to my-assignments');
    return '/dashboard/my-assignments';
  }

  // Check for other user role-based routing
  if (user.role === 'reviewer') {
    console.log('getUserHomeDirectory: User role is reviewer, redirecting to my-assignments');
    return '/dashboard/my-assignments';
  }

  if (user.role === 'admin') {
    console.log('getUserHomeDirectory: User role is admin, redirecting to assessments');
    return '/dashboard/assessments';
  }

  // Default home directory for regular users
  console.log('getUserHomeDirectory: Default redirect to assessments');
  return '/dashboard/assessments';
};

/**
 * Determines where to redirect after login based on user properties
 */
export const getPostLoginRedirect = (user: any): string => {
  return getUserHomeDirectory(user);
};

/**
 * Determines where to redirect after successful signup/invite acceptance
 */
export const getPostSignupRedirect = (user: any): string => {
  return getUserHomeDirectory(user);
};

/**
 * Gets the appropriate "Go Home" URL for error pages and navigation
 */
export const getGoHomeUrl = (user: any): string => {
  return getUserHomeDirectory(user);
};

/**
 * Navigation utilities for different user states
 */
export const NavigationUtils = {
  getUserHomeDirectory,
  getPostLoginRedirect,
  getPostSignupRedirect,
  getGoHomeUrl,
};

export default NavigationUtils;
